import {ConnectedComponent} from 'lowkey-component';

import {TextAnimation} from '@components/helpers/TextAnimation';
import {sleep} from '@lib/utils';
import {MediaQuery} from '@services/MediaQuery';
import {WindowService} from '@services/WindowService';
import {appSelectors} from '@store/appSlice';

export class Kv extends ConnectedComponent {
  private mq = MediaQuery.create();
  private windowService = WindowService.create();
  private textAnimation: TextAnimation | null = null;
  private text: HTMLParagraphElement | undefined = undefined;

  constructor(element: HTMLDivElement) {
    super(element);
  }

  didMount() {
    this.text = this.element.querySelector(
      '.s-kv_copy-text',
    ) as HTMLParagraphElement;
    this.textAnimation = new TextAnimation(this.text);
    this.textAnimation.init();

    this.observe(appSelectors.selectOrientation, this.onChangeOrientation);
    this.observe(appSelectors.selectSiteIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        this.element?.classList.add('viewed');
        await sleep(2000);
        this.textAnimation?.show();
      }
    });

    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        this.element?.classList.add('viewed');
        await sleep(100);
        this.textAnimation?.show();
      }
    });

    this.windowService.onResize.connect(this.onResizeWindow);

    this.resize();
  }

  didUnmount() {
    this.windowService.onResize.disconnect(this.onResizeWindow);
  }

  onChangeOrientation = () => {
    if (this.mq.isPhone()) {
      this.resize();
    }
  };

  onResizeWindow = () => {
    if (this.mq.isDesktop()) {
      this.resize();
    }
  };

  resize = () => {
    const height = window.innerHeight;
    this.element.style.height = `${height}px`;
  };
}
